import { KanbanPageV14 } from "./KanbanPageV14";

/*
 * InkSight Kanban scope routing
 *
 * KanbanPageV12 forced every missing or non-all view back to view=all.
 * KanbanPageV13 now records both view=mine and view=all explicitly, while
 * KanbanPageV14 handles the initial role-based default only when no choice
 * has been supplied.
 */
export const KanbanPageV15 = () => <KanbanPageV14 />;
